Vue.component('poster-draft-table-line', () => import('@/components/domains/poster-automation/PosterDraftTableLine.vue'));
Vue.component('poster-draft-table-collapse', () => import('@/components/domains/poster-automation/PosterDraftTableCollapse.vue'));



// WEBPACK FOOTER //
// ./resources/assets/js/components/domains/poster-automation/index.js